import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { TelefoonIcon } from "../../atoms/icons/TelefoonIcon";
import { EmailIcon } from "../../atoms/icons/EmailIcon";

// All the incoming values
interface IProps {
    type?: 'phone' | 'email' | 'mobile';
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<string | null>;
export const ContactInfo = (props: AllProps) => {
    const getIcon = () => {
        switch(props.type) {
            case 'email': return <EmailIcon />;
            case 'phone':
            case 'mobile':
            default: return <TelefoonIcon />;
        }
    };

    const getLabel = () => {
        switch(props.type) {
            case 'email': return props.label || "Email";
            case 'mobile': return props.label || "Mobiel";
            case 'phone': return props.label || "Telefoon";
            default: return props.label || "Contact";
        }
    };

    return (<Caption {...props} caption={getLabel()} icon={getIcon()}>
        {props.value}
    </Caption>)
}
